import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'password',
  data() {
    return {
      reason: ''
    };
  },
  head() {
    return {
      title: 'EXTRA'
    };
  },
  computed: {
    style() {
      return this.$route.query.blank ? 'opacity: 0' : '';
    }
  },
  mounted() {
    setTimeout(() => {
      this.reason = 'You can close this screen now';
    }, 3000);
  },
  beforeCreate() {
    this.$config.reportETL = false;
  }
};